<!-- @format -->
<div class="background-base-subtle hmf-px-s hmf-py-m hmf-display-flex hmf-flex-row">
	<homefield-icon
		name="security-verified-user"
		width="16px"
		height="16px"
	/>
	<div class="hmf-ml-xxs hmf-w-100">
		<p class="hmf-body-bold-m hmf-m-0">Add a No Sweat Protection Plan</p>
		<p class="hmf-body-s hmf-mb-xs">
			Get coverage for repairs or replacements that go above and beyond.
			<a
				hmf-text-link
				class="hmf-text-decoration-underline"
				size="small"
				variant="tertiary"
				linkURL="https://www.dickssportinggoods.com/s/policy/no-sweat-protection-plan?srsltid=AfmBOooxRagX3oKP5OE40VHbrejBRgFn9VzXoqOgLYYIx9FsffvHs_UF"
				target="blank"
			>
				What's Covered
			</a>
		</p>
		<ng-content></ng-content>
	</div>
</div>
